import makeStyles from '@material-ui/core/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 100,
    marginBottom: theme.spacing(4)
  },
  root: {
    '& .dropzone': {
      maxHeight: 55*3 + 'px',
      overflowY: 'auto',
      paddingRight: theme.spacing(1),
    },
    '& .dropzone li.draggable:hover': {
      background: 'rgba(0,0,0,0.07)',
      cursor: 'pointer'
    },
    '& .dropzone .MuiListItemIcon-root': {
      minWidth: 'unset',
    },
    '& .dropzone .MuiListItemIcon-root:hover': {
      cursor: 'pointer'
    },
    '& .dropzone li:nth-child(odd)': {
      borderTop: '1px solid rgba(0,0,0,0.1)',
      borderBottom: '1px solid rgba(0,0,0,0.1)',
    },
    '& .dropzone li.selectedLayer': {
      background: 'rgba(0,0,0,0.05)'
    },
    '& .layerVisibility:not(.hidden)': {
      color: theme.palette.default
    },
    '& .layerVisibility.hidden': {
      color: theme.palette.grey[300]
    },
    '& .text-wrapper': {
      whiteSpace: 'pre-wrap',
      '-webkit-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none',
      'vertical-align': 'sub'
    },
    '& #editorWrapper': {
      border: '1px dashed silver',
      overflow: 'hidden',
    },
    '& #editorWrapper.text': {
      cursor: 'text'
    },
    '& .layerIsSelected': {
      borderColor: 'transparent',
      boxShadow: '0 0 0 5px black'
    },
    '& .layerIsSelected .text-wrapper.move': {
      cursor: 'move',
    },
    '& .layerIsSelected .rightExpand': {
      zIndex: 123,
      position: 'absolute',
      width: '50px',
      top: 0,
      bottom: 0,
      right: '-25px',
      cursor: 'col-resize',
      'user-select': 'none',
    },
    '& .layerIsSelected .leftExpand': {
      zIndex: 123,
      position: 'absolute',
      width: '50px',
      top: 0,
      bottom: 0,
      left: '-25px',
      cursor: 'col-resize',
      'user-select': 'none',
    },
  },
  sideBar: {
    backgroundColor: theme.palette.grey[200],
  },
  imagePreview: {
    width: '24px',
    height: '16px',
    border: '1px solid rgba(0,0,0,0.3)',
    margin: theme.spacing(0, 2)
  },
}));


export default useStyles;